<template>
    <div class="volunteers-list">
        <TopActiveVolunteersCard v-for="volunteer in itemsList" :data="volunteer"/>
    </div>
</template>

<script>
import TopActiveVolunteersCard from './TopActiveVolunteersCard.vue';

export default {
    name: 'TopActiveVolunteersList',

    props: ['itemsList'],

    components: {
        TopActiveVolunteersCard
    }
}
</script>

<style lang="scss" scoped>
    .volunteers-list{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        column-gap: 29px;
        row-gap: 34px;

        @media(max-width: 1250px){
            column-gap: 15px;
        }

        @media(max-width: 1200px){
            grid-template-columns: 1fr 1fr 1fr;
            column-gap: 21px;
            row-gap: 25px;
        }

        @media(max-width: 991px){
            grid-template-columns: 1fr 1fr;
        }

        @media(max-width: 767px){
            grid-template-columns: 1fr;
            column-gap: 0;
            row-gap: 20px;
        }
    }
</style>